import { Fab, Grid, Typography } from "@mui/material";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

interface IParams {
    title?: string;
}

export const BackNavigation = (props: IParams) => {
    const { title } = props;
    const history = useHistory();

    const handleBack = () => {
        history.goBack();
    };

    return (
        <Grid alignContent="center" alignItems="center" className="container-boxed__title" container>
            <Grid item sm="auto" xs={2}>
                <Fab aria-label="back" color="secondary" size="small" onClick={handleBack}>
                    <KeyboardArrowLeft />
                </Fab>
            </Grid>
            <Grid item sm={11} xs={10}>
                <Typography align="center" color="secondary" variant="h2">
                    {title}
                </Typography>
            </Grid>
        </Grid>
    );
};
